import React from "react";
import Flatpickr from "react-flatpickr";
import dbTime from "../Utilities/dbTime";
import {TextField} from "@mui/material";
import dbDate from "../Utilities/dbDate";


export default function DateTimeFlatpicker({label, ...props}) {
    const sx = props.sx !== undefined ? props.sx : {marginTop: '8px', marginBottom: '8px'};
    return (
        <Flatpickr
            options={{
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                time_24hr: true
            }}
            {...props}
            render={({ defaultValue, value }, ref) => (
                <TextField fullWidth={true} label={label} sx={sx} value={`${dbDate(value)} ${dbTime(value)}`} inputRef={ref} />
            )}
        />
    );
}